import { Box, Typography, Button } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useIntl } from 'react-intl';
import logo from '../../assets/logo-black.svg';
import CrispCTAButton from '../crisp-cta-button';

const AccessError = () => {
	const intl = useIntl();
	const { logout } = useAuth0();

	const handleLogout = () => {
		logout({ logoutParams: { returnTo: window.location.origin } });
	};

	return (
		<Box
			sx={{
				backgroundColor: '#efefef',
				minHeight: '100vh',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<Box
				sx={{
					padding: '48px',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					maxWidth: '600px',
				}}
			>
				<img src={logo} style={{ width: '100%', maxWidth: '175px', marginBottom: '24px' }} alt='Nuqlea Logo' />

				<Typography
					sx={{
						textAlign: 'center',
						marginBottom: '16px',
						fontSize: '26px',
						fontWeight: 600,
					}}
				>
					{intl.formatMessage({ id: 'unauthorized.title' })}
				</Typography>

				<Typography
					sx={{
						textAlign: 'center',
						fontSize: '16px',
						marginBottom: '8px',
						color: '#666',
					}}
				>
					{intl.formatMessage({ id: 'unauthorized.description' })}
				</Typography>

				<Typography
					sx={{
						textAlign: 'center',
						fontSize: '16px',
						marginBottom: '24px',
						color: '#666',
					}}
				>
					{intl.formatMessage({ id: 'unauthorized.contact' })}
				</Typography>

				<Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
					<Button
						onClick={handleLogout}
						variant='contained'
						sx={{
							background: '#000',
							color: '#FFF',
							border: '1px solid #000',
							borderRadius: '10px',
							minWidth: '140px',
							'&:hover': {
								background: '#333',
							},
						}}
					>
						{intl.formatMessage({ id: 'unauthorized.logout' })}
					</Button>
				</Box>

				<CrispCTAButton variant='link' className='mt-6' />
			</Box>
		</Box>
	);
};

export default AccessError;
